import { render } from "./EmployeeApprovedLiquidations.vue?vue&type=template&id=fa268018"
import script from "./EmployeeApprovedLiquidations.vue?vue&type=script&lang=js"
export * from "./EmployeeApprovedLiquidations.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__